const en = require('./en_US');
const zhCN = require('./zh_CN');
const zhTW = require('./zh_TW');


function handeOtherKey(i18nObjs) {
	const i18nFileNames = ['zh_TW', 'en_US', 'zh_CN'];

	if (typeof window === 'undefined') {
		try {
			const fs = typeof window === 'object' ? null : eval('require("fs")');
			const path = typeof window === 'object' ? null : eval('require("path")');
			if (!fs || !path) return;

			fs.readdirSync(__dirname).forEach(file => {
				// console.log(file, 'filePath');
				const filePath = path.resolve(__dirname, file);
				const isDir = fs.lstatSync(filePath).isDirectory();

				if (isDir) {
					fs.readdirSync(filePath).forEach(subFile => {
						const index = i18nFileNames.indexOf(subFile.replace('.js', ''));
						if (index === -1) return;
						const subFilePath = path.resolve(filePath, subFile);
						const _obj = eval(`require('${subFilePath.replace(/\\/g, '/')}')`);
						Object.keys(_obj).forEach(key => {
							i18nObjs[index][key] = _obj[key];
						});
					});
				}
			});
		} catch (error) {
			console.log('error', error, __dirname);
		}
	} else {
		const context = require.context('./', true, /\.js$/);
		context.keys().forEach(file => {
			if (i18nFileNames.find(name => file === `./${name}.js`)) return;
			if (file === './index.js') return;
			const fileName = file.split('/').pop().replace('.js', '');
			const index = i18nFileNames.indexOf(fileName);
			const _obj = context(file);

			Object.keys(_obj).forEach(key => {
				i18nObjs[index][key] = _obj[key];
			});
		});
	}
}

function mergeI18nObj(...i18nObjs) {
	const newI18nObj = {};
	const mainI18nObj = i18nObjs[0] || {};

	handeOtherKey(i18nObjs);

	Object.keys(mainI18nObj).forEach(key => {
		const sObj = mainI18nObj[key];
		newI18nObj[key] = {};
		Object.keys(sObj).forEach(sKey => {
			newI18nObj[key][sKey] = i18nObjs.reduce((pre, cur) => {
				return [...pre, cur?.[key]?.[sKey] || mainI18nObj[key][sKey]];
			}, []);
		});
	});

	return newI18nObj;
}

module.exports = mergeI18nObj(zhTW, en, zhCN);
